import type { AutoFormWidgetsProps } from '../autoForm'
import { InputWidget } from './inputWidget'

export function NumberWidget(props: AutoFormWidgetsProps) {
  return <InputWidget type="number" {...props} />
}
